"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _Review = _interopRequireDefault(require("ecosystem-marketplace-core/records/Review"));

var _ReviewStats = _interopRequireDefault(require("ecosystem-marketplace-core/records/ReviewStats"));

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var initialState = _immutable.default.fromJS({
  list: new _immutable.default.List(),
  stats: new _ReviewStats.default(),
  total: 0
});

var reviews = function reviews() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case ActionTypes.REVIEWS_FETCH_RECEIVED:
      return state.set('list', new _immutable.default.List(_Review.default.fromArray(payload.reviews))).set('total', payload.total);

    case ActionTypes.REVIEWS_STATS_RECEIVED:
      return state.set('stats', _ReviewStats.default.from(payload));

    case ActionTypes.REVIEW_HELPFUL_RECEIVED:
      {
        var indexToUpdate = state.get('list').findIndex(function (review) {
          return review.get('id') === payload.reviewId;
        });
        return state.set('list', state.get('list').update(indexToUpdate, function (review) {
          return review.toggleHelpful(payload.reviewId, payload.userId, payload.isHelpful);
        }));
      }

    default:
      return state;
  }
};

var _default = reviews;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/reviews.js
// module id = 641
// module chunks = 209 210 211 212